import Marquee from "react-fast-marquee";

const WORDS = ["Madu Hutan", "Madu Randu", "Madu Kelengkeng", "100% Murni", "Panen Lokal"];

export const MarqueeStrip = () => {
  return (
    <section className="bg-ink py-8 md:py-10 overflow-hidden border-y border-honey/20">
      <Marquee speed={45} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="marquee-serif text-cream text-4xl md:text-6xl px-8 md:px-12 tracking-tight">
              {w}
            </span>
            <span className="text-honey text-3xl md:text-5xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
